export default "__VITE_ASSET__DvaL8Exc__"